import { SmartAnswersResult } from '@/_generated/api-clients/xp';
import { store as jotaiStore } from '@/atoms/store';
import { userPrefsAtom } from '@/atoms/userPrefs';
import { env } from '@/env';

export const SMART_SEARCH_FEEDBACK_FORM_ID = 'omjVtnhI';

interface SmartSearchFeedbackFieldsProps {
  feedbackResponse: string;
  smartAnswer: SmartAnswersResult;
  question: string;
  userFullName: string;
}

export const getSmartSearchFeedbackHiddenFields = ({
  feedbackResponse,
  smartAnswer,
  question,
  userFullName,
}: SmartSearchFeedbackFieldsProps): Record<string, string> => {
  const now = new Date();
  const date = now.toLocaleDateString();
  const time = now.toLocaleTimeString();

  const { country } = jotaiStore.get(userPrefsAtom);
  const { parameters } = smartAnswer;

  return {
    name: userFullName,
    country: country.id ?? 'Unknown',
    date_raw: now.getTime().toString(),
    date: `${date} ${time}`,
    question,
    answer: smartAnswer.answer ?? 'No answer',
    feedback_response: feedbackResponse,
    model: parameters.model ?? 'Unknown',
    model_provider: parameters.provider ?? 'Unknown',
    min_answer_source_confidence:
      parameters.minAnswerSourceConfidence ?? 'Unknown',
    temperature:
      parameters.temperature != null
        ? String(parameters.temperature)
        : 'Unknown',
    prompt_instructions: parameters.promptInstructions ?? 'Unknown',
    env: env.REACT_APP_ENV,
  };
};
